import { useEffect, useState } from "react";
import setThemeColor from "../../utils/setThemeColor/setThemeColor";
import styles from "./InfoPage.module.css";
import { NavMenu } from "../../components/feature/NavMenu/NavMenu";
import { RootState } from "../../redux/store";
import { IOptions } from "../../components/feature/NavMenu/elements/AdditionalOptionsMenu/AdditionalOptionsMenu";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import setWebPageTitle from "../../utils/setWebPageTitle/setWebPageTitle";
import setWebPagePreviewImage from "../../utils/setWebPagePreviewImage/setWebPagePreviewImage";

const MorePage: React.FC = () => {
    const { t } = useTranslation();
    const isLoggedIn = useSelector((state: RootState) => state.client.isLoggedIn);
    const [options, setOptions] = useState<IOptions[]>([]);
    const isMobile: boolean = useSelector((state: RootState) => state.client.isMobile);

    useEffect(() => {
        setThemeColor("#ffffff");
        setWebPageTitle("Info");
        setWebPagePreviewImage();
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            setOptions([
                {
                    link: "/",
                    name: t("containers.myRecipesPage.title"),
                    icon: <i className="bi bi-collection"></i>,
                },
                {
                    link: "/explore",
                    name: t("containers.explorePage.title"),
                    icon: <i className="bi bi-globe-americas"></i>,
                },
                {
                    link: "/add",
                    name: t("containers.addRecipePage.title"),
                    icon: <i className="bi bi-plus-circle"></i>,
                },
                {
                    link: "/settings",
                    name: t("containers.settingsPage.title"),
                    icon: <i className="bi bi-gear"></i>,
                },
            ]);
        } else {
            setOptions([
                {
                    link: "/explore",
                    name: t("containers.explorePage.title"),
                    icon: <i className="bi bi-globe-americas"></i>,
                },
                {
                    link: "/settings",
                    name: t("containers.settingsPage.title"),
                    icon: <i className="bi bi-gear"></i>,
                },
            ]);
        }
    }, [isLoggedIn]);

    return (
        <div>
            <NavMenu
                options={options}
                title={
                    <span>
                        <i className="bi bi-info-circle"></i> {t("containers.infoPage.title")}
                    </span>
                }
            />
            {isMobile && (
                <p className={styles.title}>
                    <span>
                        <i className="bi bi-info-circle"></i> {t("containers.infoPage.title")}
                    </span>
                </p>
            )}
            <div className={styles.container}>
                <h5 className="my-3">{t("containers.infoPage.legal")}</h5>
                <p>Copyright © 2025 Wilcz.com. All Rights Reserved.</p>
                <h5 className="my-3">{t("containers.infoPage.contact")}</h5>
                <p>contact@wilcz.com</p>
            </div>
        </div>
    );
};

export default MorePage;
